import React, { useState } from "react";

const Mahni = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  const products = [
    { 
      id: 81, 
      img: "https://i.postimg.cc/brSr8W50/image.png",
      caption: "عناية تمريضية"
    },
    { 
      id: 82, 
      img: "https://i.postimg.cc/vT7BcfQD/image.png",
      caption: "فندقية"
    },
    { 
      id: 83, 
      img: "https://i.postimg.cc/gjc9HZVx/image.png",
      caption: "محاسبة"
    },
    { 
      id: 84, 
      img: "https://i.postimg.cc/hPjWJV4w/image.png",
      caption: "المعلوماتية الادارية"
    },
    { 
      id: 84, 
      img: "https://i.postimg.cc/BbzhPLM9/image.png",
      caption: "المعلوماتية: البرمجة"
    },
     { 
      id: 84, 
      img: "https://i.postimg.cc/J4Bxdhp0/image.png",
      caption: "رسم معماري"
    },
     { 
      id: 84, 
      img: "https://i.postimg.cc/bdXxjQmJ/image.png",
      caption: "كهرباء"
    },
     { 
      id: 84, 
      img: "https://i.postimg.cc/HkgNw5Td/2.png",
      caption: "ميكانيك"
    },
  ];

  return (
    <section className="shop">
      <h1 className="section-title"> BP /BT /TS /LT مهني</h1>
      <div className="product-list">
        {products.map((product) => {
          const whatsappMessage = `مرحبا هل يمكني انا استفسر عن التعليم الخصوصي للمهني (${product.caption}).`;
          const whatsappLink = `https://wa.me/70163001?text=${encodeURIComponent(whatsappMessage)}`;

          return (
            <div key={product.id} className="product-box">
              <div className="img-box">
                <img 
                  src={product.img} 
                  alt={product.caption} 
                  onClick={() => setSelectedImg(product.img)} 
                />
              </div>

              {/* الكابشن */}
              <p className="product-caption">{product.caption}</p>
               <br/>
              <a 
                href={whatsappLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="whatsapp-card"
              >
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
                  alt="WhatsApp" 
                  width="25" 
                  height="25" 
                />
                <span>التواصل عبر الواتس اب</span>
              </a>
            </div>
          );
        })}
      </div>

      {/* نافذة تكبير الصورة */}
      {selectedImg && (
        <div className="popup" onClick={() => setSelectedImg(null)}>
          <span className="close">&times;</span>
          <img src={selectedImg} alt="Zoomed" className="popup-img" />
        </div>
      )}
    </section>
  );
};

export default Mahni;
